'use client';

import React, { JSX } from 'react';
import ProvidersClient from './ProvidersClient';


/**
 * Props for the ProvidersWrapper component.
 * @typedef {Object} ProvidersWrapperProps
 * @property {React.ReactNode} children - The child components to be wrapped.
 * @property {Object} params - The parameters for the wrapper.
 * @property {string} params.locale - The locale parameter.
 */
type ProvidersWrapperProps = {
  children: React.ReactNode;
  params: {
    locale: string;
  };
};

/**
 * A wrapper component that provides context to its children.
 * @param {ProvidersWrapperProps} props - The props for the component.
 * @returns {JSX.Element} The wrapped children components.
 */
export const ProvidersWrapper: React.FC<ProvidersWrapperProps> = ({
  params,
  children,
}: ProvidersWrapperProps): JSX.Element => {
  return <ProvidersClient params={params}>{children}</ProvidersClient>;
};
